module.exports = __webpack_public_path__ + "static/media/TrueNorth_editvars_thumb.56a80885.png";